document.addEventListener("DOMContentLoaded", function () {
  function iniciarCodigo() {
    var debug = false;
    var productSelectorHtml = '.main-product__add-to-cart [name="id"]';

    function log(text) {
      if (debug) console.log(text);
    }

    function formatMoney(cents, format = "R$ {{amount_no_decimals_with_comma_separator}}") {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      let value = (cents / 100).toFixed(2);
      const formatted = {
        "{{amount}}": value,
        "{{amount_no_decimals}}": Math.round(value),
        "{{amount_with_comma_separator}}": value.replace(".", ","),
        "{{amount_no_decimals_with_comma_separator}}": Math.round(value).toString().replace(".", ","),
        "{{amount_with_apostrophe_separator}}": value.replace(".", "'")
      };
      return format.replace(/{{\s*([\w_]+)\s*}}/g, (match, key) => formatted[key] || value);
    }

    // Funções para manipulação do cookie do carrinho
    function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
    }
    function updateCartCookie(value) {
      var date = new Date();
      date.setTime(date.getTime() + (14 * 86400000)); // 14 dias
      var expires = "; expires=" + date.toGMTString();
      document.cookie = "cart=" + value + expires + "; path=/";
    }

    var productSection = document.getElementById('frete-produto');
    if (!productSection) {
      log("Elemento 'frete-produto' não encontrado.");
      return;
    }
    var productSelect = document.querySelector(productSelectorHtml) || document.getElementsByName('id')[0];
    if (!productSelect) {
      log("Elemento 'productSelect' não encontrado.");
      return;
    }

    var shippingMessage = document.createElement('p');
    var shippingCountry = document.createElement('select');
    var shippingProvince = document.createElement('select');
    var shippingZip = document.createElement('input');
    var shippingCepContainer = document.createElement('div');
    var freteLista = document.createElement('div');

    shippingCepContainer.classList.add('cep-container');
    shippingMessage.classList.add('erros-fretes');
    shippingMessage.style.display = "none";
    freteLista.classList.add('listas-de-fretes');
    freteLista.style.display = "none";

    function initFields() {
      // País
      shippingCountry.id = "pais-simulator";
      ['Brazil'].forEach((country, i) => {
        shippingCountry.add(new Option(country, country, i === 0));
      });
      shippingCountry.name = 'shipping_address[country]';

      // Estados
      shippingProvince.id = "estados-simulator";
      [
        'Acre', 'Alagoas', 'Amapa', 'Amazonas', 'Bahia', 'Ceara', 'Distrito Federal', 'Espirito Santo',
        'Goias', 'Maranhao', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Para', 'Paraiba',
        'Parana', 'Pernambuco', 'Piaui', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul',
        'Rondonia', 'Roraima', 'Santa Catarina', 'Sao Paulo', 'Sergipe', 'Tocantins'
      ].forEach((prov, i) => {
        shippingProvince.add(new Option(prov, prov, i === 0));
      });
      shippingProvince.name = 'shipping_address[province]';

      // CEP
      shippingZip.type = 'text';
      shippingZip.name = 'shipping_address[zip]';
      shippingZip.className = 'Form__Input cep-calculo-frete form-control';
      shippingZip.placeholder = 'Digite seu CEP';

      var headerFormulario = document.createElement('h3');
      headerFormulario.className = 'widget-frete-header';
      headerFormulario.innerText = 'Simule seu frete';

      var shippingCalcWrapper = document.createElement('div');
      shippingCalcWrapper.className = 'shipping-calc-wrapper';

      var formularioFrete = document.createElement('div');
      formularioFrete.className = 'formulario-frete';

      var shippingCalcButton = document.createElement('button');
      shippingCalcButton.innerText = 'Calcular';
      shippingCalcButton.className = 'btn btn-underline button--primary button';

      // Spinner de loading
      var spinner = document.createElement('div');
      spinner.className = 'spinner';
      spinner.style.display = 'none';
      shippingCalcButton.appendChild(spinner);

      // Reseta o botão
      window.resetButtonState = function() {
        shippingCalcButton.classList.remove('loading');
        spinner.style.display = 'none';
        shippingCalcButton.innerText = 'Calcular';
        shippingCalcButton.disabled = false;
      };

      // CSS para o spinner
      var style = document.createElement('style');
      style.innerHTML = `
        .spinner {
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          animation: spin 1s linear infinite;
          display: inline-block;
          vertical-align: middle;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .loading {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `;
      document.head.appendChild(style);

      shippingCalcButton.onclick = function () {
        var cepLimpo = shippingZip.value.replace(/\D/g, '');
        if (!cepLimpo) return;
        shippingMessage.innerHTML = '';
        shippingMessage.style.display = "none";

        // Exibe o spinner
        shippingCalcButton.innerText = '';
        shippingCalcButton.classList.add('loading');
        spinner.style.display = 'inline-block';
        shippingCalcButton.appendChild(spinner);
        shippingCalcButton.disabled = true;

        fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
          .then(response => {
            if (!response.ok) throw new Error(`Erro HTTP: ${response.status}`);
            return response.json();
          })
          .then(dados => {
            if (!dados.erro) {
              var estadosMap = {
                'AC': 'Acre', 'AL': 'Alagoas', 'AP': 'Amapa', 'AM': 'Amazonas', 'BA': 'Bahia',
                'CE': 'Ceara', 'DF': 'Distrito Federal', 'ES': 'Espirito Santo', 'GO': 'Goias',
                'MA': 'Maranhao', 'MT': 'Mato Grosso', 'MS': 'Mato Grosso do Sul', 'MG': 'Minas Gerais',
                'PA': 'Para', 'PB': 'Paraiba', 'PR': 'Parana', 'PE': 'Pernambuco', 'PI': 'Piaui',
                'RJ': 'Rio de Janeiro', 'RN': 'Rio Grande do Norte', 'RS': 'Rio Grande do Sul',
                'RO': 'Rondonia', 'RR': 'Roraima', 'SC': 'Santa Catarina', 'SP': 'Sao Paulo',
                'SE': 'Sergipe', 'TO': 'Tocantins'
              };
              shippingProvince.value = estadosMap[dados.uf] || dados.uf;
              // Chama a função de cotação com a variação selecionada
              getRates(parseInt(productSelect.value || productSelect.options[1].value));
            } else {
              shippingMessage.innerHTML = 'CEP não encontrado, tente novamente.';
              shippingMessage.style.display = "flex";
              window.resetButtonState();
            }
          })
          .catch(error => {
            console.error("Erro na requisição:", error);
            shippingMessage.innerHTML = 'Erro ao buscar CEP, tente novamente.';
            shippingMessage.style.display = "flex";
            window.resetButtonState();
          });
      };

      shippingCepContainer.appendChild(shippingZip);
      shippingCepContainer.appendChild(shippingCalcButton);
      formularioFrete.appendChild(headerFormulario);
      formularioFrete.appendChild(shippingCountry);
      formularioFrete.appendChild(shippingProvince);
      formularioFrete.appendChild(shippingCepContainer);
      shippingCalcWrapper.appendChild(formularioFrete);
      shippingCalcWrapper.appendChild(shippingMessage);
      shippingCalcWrapper.appendChild(freteLista);
      productSection.appendChild(shippingCalcWrapper);
    }

    function getRates(variantId) {
      if (!variantId) return;
      var productQuantity = document.getElementById('Quantity');
      var quantity = productQuantity ? parseInt(productQuantity.value) : 1;
      var addData = { id: variantId, quantity: quantity };

      // Manipulação do cookie: salva o cookie original e altera para um valor fake
      var originalCookie = getCookie('cart');
      var tempCookie = "temp-cart-cookie___" + Date.now();
      var fakeCookie = "fake-cart-cookie___" + Date.now();

      if (!originalCookie || originalCookie.length < 32) {
        log('Nenhum cookie encontrado. Criando temporário.');
        updateCartCookie(tempCookie);
        originalCookie = getCookie('cart');
      }
      log('Cookie original: ' + originalCookie);
      updateCartCookie(fakeCookie);
      log('Cookie alterado para: ' + getCookie('cart'));

      // Adiciona o produto ao carrinho e busca as opções de frete
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(addData),
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(() => {
        return fetch(`/cart/shipping_rates.json?_easygift_internal=true&shipping_address[country]=Brazil&shipping_address[province]=${shippingProvince.value}&shipping_address[zip]=${shippingZip.value}`);
      })
      .then(response => response.json())
      .then(d => {
        freteLista.innerHTML = "";
        if (d.shipping_rates && d.shipping_rates.length) {
          d.shipping_rates.forEach(rate => {
            var entrega = rate.delivery_days ? `Até ${rate.delivery_days[1]} dias úteis` : "Estimativa de entrega indisponível";
            var valorFrete = rate.price === "0.00" || rate.price == null
              ? "Grátis"
              : `${formatMoney(rate.price, 'R$ {{amount_no_decimals_with_comma_separator}}')}`;
            var freteItem = document.createElement('div');
            freteItem.className = "frete-item";
            freteItem.innerHTML = `
              <div>
                <p class="m-0 nome-frete"><b>${rate.name}</b> <span class="estimativa-de-entrega">${entrega}</span></p>
              </div>
              <div class="frete-valor">Valor: <b>${valorFrete}</b></div>
            `;
            freteLista.appendChild(freteItem);
          });
          freteLista.style.display = "block";
        } else {
          shippingMessage.innerHTML = 'Nenhuma opção de frete encontrada para este CEP.';
          shippingMessage.style.display = "flex";
        }
      })
      .catch(e => {
        console.error(e);
        shippingMessage.innerHTML = 'Erro ao buscar opções de frete.';
        shippingMessage.style.display = "flex";
      })
      .finally(() => {
        updateCartCookie(originalCookie);
        log('Cookie restaurado: ' + getCookie('cart'));
        window.resetButtonState();
      });
    }

    initFields();
  }

  iniciarCodigo();
});
